var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showToolTip,
      expression: "showToolTip"
    }],
    class: "customizer-3D-".concat(_vm.cssName)
  }, [_vm.asset ? _c('img', {
    attrs: {
      "src": _vm.asset
    }
  }) : _vm._e(), _c('div', {
    class: "customizer-3D-".concat(_vm.cssName, "-text")
  }, [_vm._v(_vm._s(_vm.translations[_vm.message]))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }